'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __chunk_1 = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);

function useMergedState(initialState) {
  var _useState = React.useState(initialState),
      _useState2 = __chunk_1.slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var setMergedState = function setMergedState(updater) {
    setState(function (prev) {
      var newState;

      if (typeof updater === 'function') {
        newState = updater(prev);
      } else {
        newState = updater;
      }

      return __chunk_1.objectSpread({}, prev, newState);
    });
  };

  return [state, setMergedState];
}

exports.useMergedState = useMergedState;
